import { useContext, useEffect, useState } from "react"

//Partner
import ReferralEntityFormChangeRequestItem from "./ReferralEntityFormChangeRequestItem"
import { refApiReferralEntityChangeRequestProcess } from "../../../partnerAPI"

//Helper
import { LogError } from "../../../../../helpers/logger"

// Context
import { UserContext } from "../../../../../context/userContext"

//PrimeReact
import { confirmPopup } from "primereact/confirmpopup" // To use confirmPopup method

//Styles
import myStyles from "../../../../../styles/referrals/ReferralEntityFormChangeRequestItem.module.css"

export default function ReferralEntityFormChangeRequests({
  changeRequests,
  onUpdateChangeRequests,
  onRefreshProfile,
  onUpdateSoarOrganization,
}) {
  const userCtx = useContext(UserContext)

  const [isLoading, setIsLoading] = useState(false)
  const [localChangeRequests, setLocalChangeRequests] = useState(changeRequests)

  const isPartner =
    userCtx.session.user.staff_role === 9 ||
    userCtx.session.user.staff_role === 10
  const unprocessedChangeCounts = localChangeRequests?.filter(
    (request) => request.accepted === true || request.accepted === false
  ).length

  useEffect(() => {
    setLocalChangeRequests(changeRequests)
  }, [changeRequests])

  const setChangeRequestToProcess = (changeRequestItem, accept) => {
    const newChangeRequests = localChangeRequests.map((request) => {
      if (request.id === changeRequestItem.id) {
        return { ...request, accepted: accept }
      } else {
        return request
      }
    })

    //Process immediately if this is the creator (Staff) user
    if (userCtx.session.user.staff_id === changeRequestItem.requestUserId) {
      processChangeRequest([{ ...changeRequestItem, accepted: accept }])
      notifyParentOfChangeProcess([changeRequestItem])
    } else {
      setLocalChangeRequests(newChangeRequests)
    }
  }

  const notifyParentOfChangeProcess = (requests) => {
    const newChangeRequests = [
      ...changeRequests.filter(
        (change) => !requests.some((request) => request.id === change.id)
      ),
    ]

    onUpdateChangeRequests(newChangeRequests)

    if (
      requests.some((request) => request.accepted === true) &&
      !!onRefreshProfile
    ) {
      onRefreshProfile()
    }
  }

  const processChangeList = async (listToProcess) => {
    setIsLoading(true)

    const processChanges = (listToProcess || localChangeRequests).filter(
      (request) => request.accepted !== null && request.accepted !== undefined
    )

    if (processChanges.length > 0) {
      await processChangeRequest(processChanges)

      notifyParentOfChangeProcess(processChanges)
    } else {
      userCtx.setNotificationError(`Processed changes not found`)
    }

    setIsLoading(false)
  }

  const processChangeRequest = async (changeRequestItems) => {
    try {
      const entities = [
        ...new Set(
          changeRequestItems.map((request) => request.referralEntityId)
        ),
      ]

      for (const entity of entities) {
        const filteredRequests = changeRequestItems.filter(
          (request) => request.referralEntityId === entity
        )

        const requests = filteredRequests.map((request) => {
          return { id: request.id, accept: request.accepted }
        })

        const payload = {
          userGuid: userCtx.session.user.staff_id,
          organizationId: userCtx.session.user.organization_id,
          referralEntityId: entity,
          changeFields: requests,
        }

        const result = await refApiReferralEntityChangeRequestProcess(
          userCtx.token,
          payload
        )

        if (
          filteredRequests.some(
            (request) => request.fieldName === "name" && request.accepted
          )
        ) {
          onUpdateSoarOrganization(result)
        }
      }
    } catch (error) {
      const msg = !!error.isAxiosError
        ? `: ${error.response.data}`
        : ", see console for details"
      LogError("Unable to process change request", error)
      userCtx.setNotificationError(`Unable to process change request${msg}`)
    }
  }

  const acceptAll = async () => {
    const newChangeRequests = localChangeRequests.map((request) => {
      return { ...request, accepted: true }
    })

    //Process immediately if this is the creator (Staff) user
    setLocalChangeRequests(newChangeRequests)
    await processChangeList(newChangeRequests)
  }

  const declineAll = async () => {
    const newChangeRequests = localChangeRequests.map((request) => {
      return { ...request, accepted: false }
    })

    //Process immediately if this is the creator (Staff) user
    setLocalChangeRequests(newChangeRequests)
    await processChangeList(newChangeRequests)
  }

  return (
    <div style={{ width: "100%" }}>
      {isPartner && localChangeRequests.length > 0 ? (
        <>
          <button
            type="button"
            className={`btn ${myStyles.processButton}`}
            onClick={() => {
              processChangeList()
            }}
            disabled={isLoading}
          >{`Submit processed changes: ${unprocessedChangeCounts}`}</button>
          <button
            type="button"
            className={`btn ${myStyles.processButton}`}
            onClick={(event) => {
              confirmPopup({
                target: event.currentTarget,
                message:
                  "Are you sure you want to decline all change requests?",
                icon: "pi pi-exclamation-triangle",
                accept: () => {
                  declineAll()
                },
                reject: () => {},
              })
            }}
            disabled={isLoading}
          >
            Decline all
          </button>
          <button
            type="button"
            className={`btn ${myStyles.processButton}`}
            onClick={(event) => {
              confirmPopup({
                target: event.currentTarget,
                message: "Are you sure you want to accept all change requests?",
                icon: "pi pi-exclamation-triangle",
                accept: () => {
                  acceptAll()
                },
                reject: () => {},
              })
            }}
            disabled={isLoading}
          >
            Accept all
          </button>
        </>
      ) : null}
      {localChangeRequests.map((request, index) => {
        return (
          <ReferralEntityFormChangeRequestItem
            changeRequestItem={request}
            isLoading={isLoading}
            onSetLoading={setIsLoading}
            onProcessRequest={(requestItem, accepted) => {
              setChangeRequestToProcess(requestItem, accepted)
            }}
            key={index}
          />
        )
      })}
    </div>
  )
}
